import React from "react";

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const highlightKycSearchText = (text, searchTerm) => {
	const source = text == null ? "" : String(text);
	const query = (searchTerm || "").trim();
	if (!query || !source) {
		return source;
	}

	const regex = new RegExp(`(${escapeRegExp(query)})`, "gi");
	const parts = source.split(regex);
	if (parts.length <= 1) {
		return source;
	}

	return parts.map((part, index) =>
		index % 2 === 1 ? (
			<mark key={`${part}-${index}`} className="kyc-search-highlight">
				{part}
			</mark>
		) : (
			part
		)
	);
};

export const renderKycSearchCell = (value, searchTerm, { emptyDisplay = "-" } = {}) => {
	if (value === undefined || value === null || value === "") {
		return <span>{emptyDisplay}</span>;
	}

	const text = String(value);
	if (text === emptyDisplay && !(searchTerm || "").trim()) {
		return <span>{emptyDisplay}</span>;
	}

	return <span>{highlightKycSearchText(text, searchTerm)}</span>;
};
